import { SealCheck } from "@phosphor-icons/react";
import type { ReactNode } from "react";

interface ModelBillingOverviewProps {
  modelName: string;
  description: string | null;
  children?: ReactNode;
}

export function ModelBillingOverview({
  modelName,
  description,
  children,
}: ModelBillingOverviewProps) {
  return (
    <div className="xl:sticky xl:top-[calc(var(--header-height)+1rem)] space-y-4">
      <p className="text-r8-lg">
        Model pricing for <span className="font-semibold">{modelName}</span>.
        Looking for volume pricing?{" "}
        <a href="mailto:sales@replicate.com">Get in touch</a>.
      </p>

      {children}

      <div className="border p-4 flex gap-2">
        <SealCheck size={20} weight="fill" className="flex-shrink-0" />
        <p>
          Official models are always on, maintained, and have predictable
          pricing.{" "}
          <a href="https://replicate.com/changelog/2025-01-29-official-models">
            Learn more
          </a>
          .
        </p>
      </div>

      {description ? (
        <>
          <div
            className="prose dark:prose-invert"
            // biome-ignore lint/security/noDangerouslySetInnerHtml: this is managed by us
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <hr />
        </>
      ) : null}

      <p>
        <a href="https://replicate.com/docs/billing">Check out our docs</a> for
        more information about how pricing works on Replicate.
      </p>
    </div>
  );
}
